/* Testimonial carousel: scroll-snap track + arrows + dots + gentle auto-advance.
   Pauses on hover/focus/touch, respects prefers-reduced-motion. */
(function () {
  'use strict';

  function init(shell) {
    if (!shell || shell.dataset.dwTestiInit) return;
    shell.dataset.dwTestiInit = '1';

    var track = shell.querySelector('[data-testi-track]');
    var slides = track ? Array.prototype.slice.call(track.children) : [];
    if (!track || slides.length < 2) return;

    var prev = shell.querySelector('[data-testi-prev]');
    var next = shell.querySelector('[data-testi-next]');
    var dotsWrap = shell.parentElement.querySelector('[data-testi-dots]');
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function slideWidth() {
      return slides[0].getBoundingClientRect().width + 20;
    }
    function perView() {
      return Math.max(1, Math.round(track.clientWidth / slideWidth()));
    }
    /* last REACHABLE position: with 2-up, 6 slides scroll to position 4 at most */
    function maxIndex() {
      return Math.max(0, slides.length - perView());
    }
    function currentIndex() {
      return Math.min(Math.round(track.scrollLeft / slideWidth()), maxIndex());
    }
    function goTo(i) {
      var max = maxIndex();
      if (i < 0) i = max;      /* loop backwards */
      if (i > max) i = 0;      /* loop forwards  */
      track.scrollTo({ left: i * slideWidth(), behavior: reduced ? 'auto' : 'smooth' });
    }

    var dots = [];
    function renderDots() {
      if (!dotsWrap) return;
      dotsWrap.textContent = '';
      dots = [];
      var count = maxIndex() + 1;
      for (var i = 0; i < count; i++) {
        (function (idx) {
          var b = document.createElement('button');
          b.type = 'button';
          b.setAttribute('role', 'tab');
          b.setAttribute('aria-label', 'Reviews position ' + (idx + 1));
          b.addEventListener('click', function () { goTo(idx); });
          dotsWrap.appendChild(b);
          dots.push(b);
        })(i);
      }
      paint();
    }
    function paint() {
      var i = currentIndex();
      dots.forEach(function (d, j) { d.setAttribute('aria-selected', String(j === i)); });
    }

    if (prev) prev.addEventListener('click', function () { goTo(currentIndex() - 1); });
    if (next) next.addEventListener('click', function () { goTo(currentIndex() + 1); });
    track.addEventListener('scroll', function () { requestAnimationFrame(paint); }, { passive: true });
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(renderDots, 200);
    });
    renderDots();

    /* auto-advance */
    if (shell.dataset.auto !== 'true' || reduced) return;
    var interval = (parseInt(shell.dataset.interval, 10) || 5) * 1000;
    var paused = false;
    ['mouseenter', 'focusin', 'touchstart'].forEach(function (ev) {
      shell.addEventListener(ev, function () { paused = true; }, { passive: true });
    });
    ['mouseleave', 'focusout'].forEach(function (ev) {
      shell.addEventListener(ev, function () { paused = false; });
    });
    setInterval(function () {
      if (paused || document.hidden) return;
      goTo(currentIndex() + 1);
    }, interval);
  }

  function scan() {
    document.querySelectorAll('[data-dw-testi]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-dw-testi]');
    if (el) init(el);
  });
})();
